import { setPreviewStatusAction as setPreviewStatusOperation } from 'editor/src/store/editorModules/preview/slice';

export default setPreviewStatusOperation;
